<template>
  <div class="layout-page">
    <bottom></bottom>
    <div class="aui-scrollView">
      <div class="home-top">
        <div class="top-content">
          <img src="../../assets/img/user.png"/>
          <div class="top-r">
            <p>账号：{{ userInfo.account }}</p>
            <p>密码：{{ userInfo.password }}</p>
          </div>
        </div>
        <div class="assert">
          <div class="vip">
            <template v-if="userInfo.vipType && userInfo.vipType !== 'none'">
              <p class="title">VIP会员</p>
              <p class="in-vip">{{ userInfo.vipEndDate }}</p>
            </template>
            <template v-else>
              <p class="title">未开通VIP</p>
            </template>
          </div>
          <div class="coin">
            <p class="title t-r">阅币</p>
            <p class="coin-amount t-r">{{ userInfo.avaliableAmount || 0 }}</p>
          </div>
        </div>
      </div>

      <div class="home-body">
        <ul>
          <li class="t1">
            <router-link to="/purchase">充值中心</router-link>
          </li>
          <!-- <li>
            <router-link to="/user/purchase/list">
                <span>充值记录</span>
              </router-link>
          </li>-->
<!--          <li>
            <router-link to="/user/purchase/history">
              <span>消费记录</span>
            </router-link>
          </li>-->
          <li class="t2">
            <router-link to="/user/bind">
              <span>绑定手机</span>
              <span v-if="userInfo.mobile">{{ userInfo.mobile }}</span>
            </router-link>
          </li>

          <li class="t3">
            <router-link to="/user/password">
              <span>修改密码</span>
            </router-link>
          </li>
          <li class="t4">
            <a :href="mailto">
              <span>联系客服</span>
            </a>
          </li>
          <li class="t5">
            <router-link to="/user/login">更换账号</router-link>
          </li>
<!--          <li class="t6">-->
<!--            <router-link to="/user/reaccount">找回账号</router-link>-->
<!--          </li>-->
          <li class="t7">
            <a :href="getCommonInfo.appDownloadUrl" target="_blank">App下载</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Bottom from '@/components/layer1/bottom'
import { mapGetters } from 'vuex'
import userService from '../../services/userService'
import { Kkconfig } from '../../assets/js/config'

export default {
  name: 'user',
  data () {
    return {
      isLogin: true,
      isVip: false,
      userInfo: {}
    }
  },
  computed: {
    ...mapGetters(['getCommonInfo']),
    mailto () {
      return Kkconfig.reqUrl.imUrl + "?account=" + this.userInfo.account
    }
  },
  methods: {
    getUserInfo () {
      userService.getUserInfo().then(res => {
        if (res.result) {
          this.userInfo = res.data
        }
      })
    },
    register () {
      userService.register()
        .then(res => {
          if (res.result) {
            this.userInfo = res.data
          }
        })
    }
  },
  components: {
    bottom: Bottom
  },
  created () {
    let currUser = userService.getLocalUserInfo()
    if (!currUser) {
      this.register()
    } else {
      this.getUserInfo()
    }
    this.$router.isBack = true
  }
}
</script>

<style scoped>
#pop-page {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
